/** Тело POST packs/{pack}/answers: вопрос пачки, результат самооценки и время на ответ в миллисекундах */
export class SaveAnswerParams {
  question: string
  result: boolean
  ms: number

  constructor({ question, result, ms }: { question: string, result: boolean, ms: number }) {
    this.question = question
    this.result = result
    this.ms = ms
  }
}
